import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout-Route fuer /zeiterfassung. Reine Wrapper-Komponente — Listen-/
 * Detail-Inhalte liegen in zeiterfassung.index.tsx und Sub-Routen.
 */
export const Route = createFileRoute('/zeiterfassung')({
  component: ZeiterfassungLayout,
});

function ZeiterfassungLayout(): JSX.Element {
  return <Outlet />;
}
